import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { 
  ListarPainelCteRequest,
  ListarPainelCteResponse,
  ListarStatusCteResponse
} from 'src/app/@shared/models/manifesto-embarque-painel-cte.model';
import { FilialService } from 'src/app/services/filial/filial.service';
import { ManifestoEmbarquePainelCteService } from 'src/app/services/manifesto-embarque-painel-cte/manifesto-embarque-painel-cte.service';
import { ProdutoService } from 'src/app/services/produto/produto.service';

@Component({
  selector: 'app-manifesto-embarque-painel-cte',
  templateUrl: './manifesto-embarque-painel-cte.component.html',
  styleUrls: ['./manifesto-embarque-painel-cte.component.scss']
})
export class ManifestoEmbarquePainelCteComponent implements OnInit {
  isLoading: boolean;
  listaCtes: any[] = null;

  listaStatus: ListarStatusCteResponse[] = [];

  clienteId: number;
  produtos: any[] = [];
  showProduto = false;
  
  private onDestroy = new Subject<void>();

  filialIdSelecionado: any;
  public filteredFiliais: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public filialMultiFilter: FormControl = new FormControl();
  filiais: any[];

  displayedColumns: string[] = [
    'detalhe',
    'filial',
    'clienteNome',
    'produtoDescricao',
    'qtdPedidos',
    'dataInclusao',
    'me',
    'numCTe',
    'chaveCTe',
    'status'
  ]
  public paging = { index: 0, size: 10, length: 0 };

  filterForm: FormGroup = new FormGroup({
      dataInicio: new FormControl(),
      dataFim: new FormControl(),
      clienteFormControl: new FormControl(),
      produtosFormControl: new FormControl(),
      filial: new FormControl(),
      numeroCte: new FormControl(),
      chaveCte: new FormControl(),
      manifestoEmbarque: new FormControl(),
      status: new FormControl(''),
      pedidoid: new FormControl(''),
  });
  get dataInicio() { return this.filterForm.get('dataInicio').value; };
  get dataFim() { return this.filterForm.get('dataFim').value; };
  get produto() { return this.filterForm.get('produtosFormControl').value; };
  get filial() { return this.filterForm.get('filial').value; };
  get numeroCte() { return this.filterForm.get('numeroCte').value; };
  get chaveCte() { return this.filterForm.get('chaveCte').value; };
  get manifestoEmbarque() { return this.filterForm.get('manifestoEmbarque').value; };
  get status() { return this.filterForm.get('status').value; };
  get pedidoid() { return this.filterForm.get('pedidoid').value; };

  detalhesCteSelected = new FormControl(0);
  detalhesCte: any[] = [];

  constructor(
    public snackBar: MatSnackBar,
    private painelCteService: ManifestoEmbarquePainelCteService,
    private produtoService: ProdutoService,
    private filialService: FilialService
  ) { }

  ngOnInit() {
    this.listarFiliais();
    this.iniciarDatas();
    this.listarStatusCte();

    this.filterForm.get('clienteFormControl').valueChanges.subscribe(
      (value: string) => {
        if (!value || value.length === 0) {
          this.showProduto = false;
          this.produtos = [];
          this.clienteId = null;
          this.filterForm.get('produtosFormControl').setValue(null);
          this.filterForm.get('produtosFormControl').updateValueAndValidity();
        }
      });
  }

  iniciarDatas() {
    const filtroFim = new Date();
    const filtroInicio = new Date(filtroFim);
    filtroInicio.setDate(filtroInicio.getDate() - 6);
    this.filterForm.get('dataInicio').setValue(filtroInicio);
    this.filterForm.get('dataFim').setValue(filtroFim);
  }

  listarStatusCte() {
    this.painelCteService.listarStatusCte().subscribe(
      (response: ListarStatusCteResponse[]) => {
        this.listaStatus = response;
      },
      (err: HttpErrorResponse) => {
        console.error(err);
        this.openSnackBar('Erro ao carregar lista de status, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
      }
    )
  }

  
  validaData() {
    const de = new Date(this.dataInicio);
    const ate = new Date(this.dataFim);
    const diffTime = Math.abs(ate.getTime() - de.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  }

  listarCtes(voltarIndex: boolean = false) {
    if (voltarIndex) {
      this.paging.index = 0;
    }

    if ((this.dataInicio && this.dataFim && (this.dataFim < this.dataInicio))) {
      return this.openSnackBar('A data término não pode ser maior que a data início!', 'OK', 5000, 'warning-snackbar');
    }

    if (this.validaData() > 7) {
      return this.openSnackBar('Por favor informe um período de busca para no máximo 7 dias!', 'OK', 5000, 'warning-snackbar');
    }
    
    this.isLoading = true;

    if (this.detalhesCteSelected.value !== 0) {
      this.detalhesCteSelected.setValue(0);
    }

    Object.keys(this.filterForm.controls).forEach((control: string) => {
      if (control !== 'produtosFormControl') {
        const typedControl: AbstractControl = this.filterForm.controls[control];
        typedControl.disable();
      }
    });

    const obj: ListarPainelCteRequest = {
      DataInclusaoDe: this.dataInicio ? this.dataInicio.toISOString().split('T')[0] : null,
      DataInclusaoAte: this.dataFim ? this.dataFim.toISOString().split('T')[0] : null,
      ClienteId: this.clienteId,
      ProdutoId: this.produto,
      NumCTe: this.numeroCte,
      Filial: this.filial,
      StatusId: this.status,
      ChaveCTe: this.chaveCte,
      ME: this.manifestoEmbarque,
      PedidoId: this.pedidoid,
      PaginaAtual: this.paging.index + 1,
      ItensPorPagina: this.paging.size
    }

    this.painelCteService.listarPainelCte(obj).subscribe(
      (response: ListarPainelCteResponse[]) => {
        this.listaCtes = response;
        response.length ? this.paging.length = response[0].totalCount : null;
      },
      (err: HttpErrorResponse) => {
        console.error(err);
        this.openSnackBar('Erro ao carregar listagem, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
      })
      .add(() => {
        Object.keys(this.filterForm.controls).forEach((control: string) => {
          if (control !== 'produtosFormControl') {
            const typedControl: AbstractControl = this.filterForm.controls[control];
            typedControl.enable();
          }
        });
        this.clienteId && (this.showProduto = true);
        this.isLoading = false;
      })
  }

  adicionarTabCteDetalhe(element: ListarPainelCteResponse) {
    const identificador = {
      filial: element.filial,
      numCTe: element.numCTe,
      chaveCTE: element.chaveCTe,
      identificacaoId: element.identificacaoId,
    }

    if (!this.checkExistTab(identificador)) {
      this.detalhesCte.push(identificador);
      this.detalhesCteSelected.setValue(this.detalhesCte.length);
    }
  }

  checkExistTab(identificador) {
    let idx = this.detalhesCte.findIndex(d => JSON.stringify(d) === JSON.stringify(identificador));
    const exists = idx !== -1
    if (exists)
      this.detalhesCteSelected.setValue(idx + 1);

    return exists;
  }

  reciverFeedback(respostaFilho) {
    this.clienteId = respostaFilho;
    respostaFilho ? this.selecionarProdutos() : this.produtos = [];
  }

  selecionarProdutos() {
    this.produtoService.selecionarProdutos(this.clienteId).subscribe(response => {
      this.produtos = response;
      this.verificaProduto();
    },
      (err: HttpErrorResponse) => {
        console.error(err);
        this.openSnackBar('Ocorreu um erro ao consultar! Tente novamente ou entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
      });
  }

  verificaProduto() {
    if (this.clienteId) {
      this.showProduto = true;
    } else {
      this.showProduto = false;
      this.produtos = [];
      this.filterForm.get('produto').setValue(null);
      this.filterForm.get('produto').updateValueAndValidity();
    }
  }

  public listarFiliais() {
    this.filialService.listarFilialDestino().subscribe((response: any) => {
      this.filiais = response.filter(x => x.descricao).sort();
      this.filteredFiliais.next(this.filiais.slice());
      this.filialMultiFilter.valueChanges
        .pipe(takeUntil(this.onDestroy))
        .subscribe(() => {
          this.filtroFilial();
        });
    },
      (err: HttpErrorResponse) => {
        console.error(err);
        this.openSnackBar('Erro ao carregar filiais, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
      });
  };

  filtroFilial() {
    if (!this.filiais) {
      return;
    }
    let search = this.filialMultiFilter.value;
    if (!search) {
      this.filteredFiliais.next(this.filiais.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredFiliais.next(
      this.filiais.filter(filial => filial.descricao.toLowerCase().indexOf(search) > -1)
    );
  }

  removerTab(index: number, event?: MouseEvent) {
    if (event) event.preventDefault();
    this.detalhesCte.splice(index, 1);
  }

  limparFiltros() {
    this.produtos = null;
    this.listaCtes = null;
    this.clienteId = null;
    this.showProduto = false;
    this.detalhesCte = [];
    this.filterForm.reset();
    this.iniciarDatas();
  }

  onPageChange(evt: { pageIndex: number, pageSize: number }) {
    this.paging.index = evt.pageIndex;
    this.paging.size = evt.pageSize;
    this.listarCtes();
  }

  openSnackBar(message: string, action: string, duration: number, panelClass?: string): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }
}
